<template>
  <div class="wizard-body columns content-box small-9">
    <form class="row" @submit.prevent="addAgents">
      <div class="medium-12 columns">
        <page-header
          :header-title="headerTitle"
          :header-content="$t('TEAMS_SETTINGS.ADD.DESC')"
        />
      </div>

      <div class="medium-12 columns">
        <div v-if="$v.selectedAgents.$error">
          <p class="error-message">
            {{ $t('TEAMS_SETTINGS.ADD.AGENT_VALIDATION_ERROR') }}
          </p>
        </div>
        <agent-selector
          :agent-list="agentList"
          :selected-agents="selectedAgents"
          :update-selected-agents="updateSelectedAgents"
          :is-working="isCreating"
          :submit-button-text="$t('TEAMS_SETTINGS.ADD.BUTTON_TEXT')"
        />
      </div>
    </form>

      <woot-modal :show.sync="showAddPopup" :on-close="hideAddPopup">
          <div  class="cust_modal">
              <div class="text-center mb-5">
                  <svg width="60" height="68" viewBox="0 0 60 68" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M50 0.666626H10C4.46667 0.666626 0 5.09996 0 10.5666V46.9333C0 52.4 4.46667 56.8333 10 56.8333H12.5333C15.2 56.8333 17.7333 57.8666 19.6 59.7333L25.3 65.3666C27.9 67.9333 32.1333 67.9333 34.7333 65.3666L40.4333 59.7333C42.3 57.8666 44.8667 56.8333 47.5 56.8333H50C55.5333 56.8333 60 52.4 60 46.9333V10.5666C60 5.09996 55.5333 0.666626 50 0.666626ZM45.6 29L41.7 40.8666C41.2 42.8333 39.1 44.4333 36.9667 44.4333H30.8C29.7333 44.4333 28.2333 44.0666 27.5667 43.4L22.6667 39.5666C22.5667 41.7 21.6 42.6 19.2333 42.6H17.6333C15.1667 42.6 14.1667 41.6333 14.1667 39.3V23.4C14.1667 21.0666 15.1667 20.1 17.6333 20.1H19.2667C21.7333 20.1 22.7333 21.0666 22.7333 23.4V24.6L29.2 15C29.8667 13.9666 31.5667 13.2333 33 13.8C34.5667 14.3333 35.5667 16.0666 35.2333 17.6L34.4333 22.8C34.3333 23.2333 34.4333 23.7 34.7333 24C35 24.3 35.4 24.5 35.8333 24.5H42.3333C43.6 24.5 44.6667 25 45.3 25.9C45.9 26.7666 46 27.8666 45.6 29Z" fill="#27AF34"/>
                  </svg>

              </div>
              <div class="text-center mb-5">
                  <h3 class="mb-3"> Your team is ready! </h3>
                  <span class="description_cust"> You can now collaborate as a team on conversations.
                  Happy supporting! </span>
              </div>
              <woot-submit-button
                      :button-text="finish_button"
                      class="ml-2 float-center center_cust"
                      @click="hideAddPopup"
              />
          </div>

      </woot-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import alertMixin from 'shared/mixins/alertMixin';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader';
import AgentSelector from '../AgentSelector';

export default {
  components: {
    PageHeader,
    AgentSelector,
  },
  mixins: [alertMixin],
  props: {
    team: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    selectedAgents: {
      isEmpty() {
        return !!this.selectedAgents.length;
      },
    },
  },

  data() {
    return {
      selectedAgents: [],
      isCreating: false,
        showAddPopup: false,
        finish_button : "Finish",
    };
  },

  computed: {
    ...mapGetters({
       agents: 'agents/getAgents',
    }),
    /* return confirmed agent list */
    agentList() {
       const confirmedAgents = this.agents.filter(agent => agent.confirmed === true);
       return confirmedAgents;
    },
    teamId() {
      return this.$route.params.teamId;
    },
    headerTitle() {
      return this.$t('TEAMS_SETTINGS.ADD.TITLE', {
        teamName: this.currentTeam.name,
      });
    },
    currentTeam() {
      return this.$store.getters['teams/getTeam'](this.teamId);
    },
  },

  mounted() {
    this.$store.dispatch('agents/get');
  },

  methods: {
    /* verify if there are selected agents or not */
    updateSelectedAgents(newAgentList) {
      this.$v.selectedAgents.$touch();
      if (newAgentList.length > 0) {
          this.selectedAgents = [...newAgentList];
      }
      else {
          this.selectedAgents = [];
      }
    },
    selectAllAgents() {
      this.selectedAgents = this.agentList.map(agent => agent.id);
    },
    async addAgents() {
      this.isCreating = true;
      const { teamId, selectedAgents } = this;

      try {
        await this.$store.dispatch('teamMembers/create', {
          teamId,
          agentsList: selectedAgents,
        });
          /*this.openAddPopup();*/
        router.replace({
          name: 'settings_teams_finish',
          params: {
            page: 'new',
            teamId,
          },
        });
        this.$store.dispatch('teams/get');
      } catch (error) {
        this.showAlert(error.message);
      }
      this.isCreating = false;
    },
      openAddPopup() {
          this.showAddPopup = true;
      },
      hideAddPopup() {
          router.push({ name: 'settings_teams_list' });
          this.showAddPopup = false;
      },
  },
};
</script>

<style scoped lang="scss">

.center_cust{
  display: block !important;
  margin-right: auto !important;
  margin-left: auto !important;
}

.description_cust{
  font-family: 'Inter' !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 17px !important;
  text-align: center !important;
  color: #737373 !important;
}

h3{
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 30px;
  color: #456987;
}

.cust_modal{
  padding: 9rem !important;
}

</style>
